import { render, staticRenderFns } from "./CreateDnat.vue?vue&type=template&id=43987381"
import script from "./CreateDnat.vue?vue&type=script&lang=js"
export * from "./CreateDnat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports